import { render } from "./InvoiceInfosModal.vue?vue&type=template&id=4834ffa6&scoped=true&ts=true&lang=pug"
import script from "./InvoiceInfosModal.vue?vue&type=script&lang=ts"
export * from "./InvoiceInfosModal.vue?vue&type=script&lang=ts"

import "./InvoiceInfosModal.vue?vue&type=style&index=0&id=4834ffa6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4834ffa6"]])

export default __exports__